import { EditorialType, TitleTree, Node, NodeTypeName, AnnoNodeTypeName } from "../domain/domain";
import { ComponentManagementActions, ComponentManagementActionType } from "./comp.actions";
import { findSubTreeByNodeId } from "../components/ComponentManagementPage/utils";

export type ComponentManagementState = {
    treeRoot: TitleTree | undefined,

    editorNode: Node | undefined,
    hoverNodeId: number | undefined,

    editorMode: "edit" | "view",
    editorialContentMode: "edit" | "view",

    editorialContentHasChanges: boolean,
    billContentHasChanges: boolean,
    selectedEditorialType: EditorialType | undefined,
    selectedAnnoType: AnnoNodeTypeName | undefined,
    editorialEditorStates: Map<EditorialType, string>,
    currentEditorTextForAnnotation: string | undefined,
    addEditNodeDialogOpen: boolean,
    addEditNodeDialogMode: "add" | "edit",
    addEditNodeDialogNodeType: NodeTypeName | undefined,
    addEditNodeDialogOrdinal: number | undefined,
    addEditNodeDialogSubTree: TitleTree | undefined,
    addEditNodeDialogDirection: String | undefined,
    addEditNodeDialogGrandParentNode: TitleTree | undefined,

    approveEdiorialContentDialogOpen: boolean,
    rejectEdiorialContentDialogOpen: boolean,

    approveComponentDialogOpen: boolean,
    rejectComponentDialogOpen: boolean,

    repealNodeDialogOpen: boolean,
    repealNodeDialogSubtree: TitleTree | undefined,

    approveAllDialogOpen: boolean,
    rejectAllDialogOpen: boolean,
    rejectAllDialogSubtree: TitleTree | undefined,

    removeNodeDialogOpen: boolean,
    removeNodeDialogSubTree: TitleTree | undefined,

    markForDeleteCheckBox: boolean,
    statuteMarkForDeleteCheckBox: boolean,
    diffChanges: boolean
    annoChanges: boolean
}

const initialState: ComponentManagementState = {
    treeRoot: undefined,
    hoverNodeId: undefined,
    editorNode: undefined,
    editorialContentHasChanges: false,
    billContentHasChanges: false,
    editorMode: "view",
    editorialContentMode: "view",
    selectedEditorialType: undefined,
    selectedAnnoType: undefined,
    editorialEditorStates: new Map(),
    addEditNodeDialogMode: "add",
    addEditNodeDialogOpen: false,
    addEditNodeDialogOrdinal: undefined,
    addEditNodeDialogSubTree: undefined,
    addEditNodeDialogNodeType: undefined,
    addEditNodeDialogDirection: undefined,
    addEditNodeDialogGrandParentNode: undefined,
    approveEdiorialContentDialogOpen: false,
    rejectEdiorialContentDialogOpen: false,
    approveComponentDialogOpen: false,
    rejectComponentDialogOpen: false,
    repealNodeDialogOpen: false,
    repealNodeDialogSubtree: undefined,
    approveAllDialogOpen: false,
    rejectAllDialogOpen: false,
    rejectAllDialogSubtree: undefined,
    removeNodeDialogOpen: false,
    removeNodeDialogSubTree: undefined,
    markForDeleteCheckBox: false,
    statuteMarkForDeleteCheckBox: false,
    diffChanges: false,
    annoChanges: false,
    currentEditorTextForAnnotation: undefined
}

export function componentManagementReducer(
    state = initialState,
    action: ComponentManagementActions
    ): ComponentManagementState {
        switch (action.type) {
            case ComponentManagementActionType.TREE_ROOT_UPDATED:
                return {
                    ...state,
                    treeRoot: action.treeRoot
                }
            case ComponentManagementActionType.EDITOR_MODE_UPDATED:
                return {
                    ...state,
                    editorMode: action.editorMode
                }
            case ComponentManagementActionType.EDITORIAL_CONTENT_MODE_CHANGED:
                return {
                    ...state,
                    editorialContentMode: action.editorialContentMode
                }
            case ComponentManagementActionType.SELECTED_EDITORIAL_TYPE_CHANGED:
                return {
                    ...state,
                    selectedEditorialType: action.selectedEditorialType
                }
            case ComponentManagementActionType.SELECTED_ANNO_TYPE_CHANGED:
                return {
                    ...state,
                    selectedAnnoType: action.selectedAnnoType
                }
            case ComponentManagementActionType.EDITORIAL_STATES_CHANGED:
                return {
                    ...state,
                    editorialEditorStates: action.editorialStates,
                    currentEditorTextForAnnotation: action.currentEditorTextForAnnotation
                }
            case ComponentManagementActionType.EDITOR_NODE_UPDATED:
                return {
                    ...state,
                    editorNode: action.editorNode
                }
            case ComponentManagementActionType.ADD_EDIT_NODE_DIALOG_OPEN:
                return {
                    ...state,
                    addEditNodeDialogOpen: action.open,
                    addEditNodeDialogMode: action.mode,
                    addEditNodeDialogSubTree: action.subTree,
                    addEditNodeDialogNodeType: action.nodeType,
                    addEditNodeDialogOrdinal: action.ordinal,
                    addEditNodeDialogDirection: action.direction,
                    addEditNodeDialogGrandParentNode: action.grandParentNode,
                }
            case ComponentManagementActionType.APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN:
                return {
                    ...state,
                    approveEdiorialContentDialogOpen: action.open
                }
            case ComponentManagementActionType.REJECT_EDITORIAL_CONTENT_DIALOG_OPEN:
                return {
                    ...state,
                    rejectEdiorialContentDialogOpen: action.open
                }
            case ComponentManagementActionType.REMOVE_NODE_DIALOG_OPEN:
                return{
                    ...state,
                    removeNodeDialogOpen: action.open,
                    removeNodeDialogSubTree: action.subTree
                }
            case ComponentManagementActionType.EDITORIAL_CONTENT_HAS_CHANGES:
                return {
                    ...state,
                    editorialContentHasChanges: action.hasChanges
                }
            case ComponentManagementActionType.BILL_CONTENT_HAS_CHANGES:
                    return {
                        ...state,
                        editorialContentHasChanges: action.billHasChanges
                    }
            case ComponentManagementActionType.STATUTE_MARK_FOR_DELETION:
                return{
                    ...state,
                    statuteMarkForDeleteCheckBox: action.mark
                }
            case ComponentManagementActionType.MARK_FOR_DELETION:
                return{
                    ...state,
                    markForDeleteCheckBox: action.mark
                }
            case ComponentManagementActionType.DIFF_HAS_CHANGES:
                return{
                    ...state,
                    diffChanges: action.diffChanges
                }
            case ComponentManagementActionType.ANNO_HAS_CHANGES:
                return{
                    ...state,
                    annoChanges: action.annoChanges
                }
            case ComponentManagementActionType.APPROVE_COMPONENT_DIALOG_OPEN:
                return {
                    ...state,
                    approveComponentDialogOpen: action.open
                }

            case ComponentManagementActionType.REJECT_COMPONENT_DIALOG_OPEN:
                return {
                    ...state,
                    rejectComponentDialogOpen: action.open
                }
            case ComponentManagementActionType.REPEAL_NODE_DIALOG_OPEN:
                return{
                    ...state,
                    repealNodeDialogOpen: action.open,
                    repealNodeDialogSubtree: action.subTree
                }
            case ComponentManagementActionType.APPROVE_ALL_NODE_DIALOG_OPEN:
                return{
                    ...state,
                    approveAllDialogOpen: action.open
                }
            case ComponentManagementActionType.REJECT_ALL_DIALOG_OPEN:
                return{
                    ...state,
                    rejectAllDialogOpen: action.open,
                    rejectAllDialogSubtree: action.subTree
                }
            case ComponentManagementActionType.HEADING_CHANGED:
                if (state.treeRoot === undefined) {
                    return state;
                }
                let tempRootForHeading = {...state.treeRoot};
                let tempNodeForHeading = findSubTreeByNodeId(tempRootForHeading, action.nodeId);
                if (!tempNodeForHeading) {
                    return state;
                }
                tempNodeForHeading.headingHasChanges = action.headingHasChanges;

                return {
                    ...state,
                    treeRoot: tempRootForHeading
                }
            case ComponentManagementActionType.STATUTORY_CONTENT_CHANGED:
                if (state.treeRoot === undefined) {
                    return state;
                }
                let tempRootForStatutory = {...state.treeRoot};
                let tempNodeForStatutory = findSubTreeByNodeId(tempRootForStatutory, action.nodeId);
                if (!tempNodeForStatutory) {
                    return state;
                }
                tempNodeForStatutory.workingCopyHasChanges = action.statutoryContentHasChanges;

                return {
                    ...state,
                    treeRoot: tempRootForStatutory
                }
            case ComponentManagementActionType.EDITORIAL_CONTENT_CHANGED:
                if (state.treeRoot === undefined) {
                    return state;
                }
                let tempRootForEditorial = {...state.treeRoot};
                let tempNodeForEditorial = findSubTreeByNodeId(tempRootForEditorial, action.nodeId);
                if (!tempNodeForEditorial) {
                    return state;
                }
                tempNodeForEditorial.editorialHasChanges = action.editorialContentHasChanges;

                return {
                    ...state,
                    treeRoot: tempRootForEditorial
                }
            case ComponentManagementActionType.SUBTREE_TITLE_CHANGED:
                if (state.treeRoot === undefined) {
                    return state;
                }
                let newRoot = {...state.treeRoot};
                let node = findSubTreeByNodeId(newRoot, action.nodeId);
                if (!node) {
                    return state;
                }
                node.heading = action.newHeading;
                node.workingCopyHeading = action.newWorkingCopyHeading;
                node.citation = action.newCitation;
                node.citationPart = action.newCitationPart;
                node.workingCopyCitation = action.newWorkingCopyCitation;
                node.subTreeHasUnapprovedChanges = true;
                node.repealed = action.repealed;

                return {
                    ...state,
                    treeRoot: newRoot
                }
            case ComponentManagementActionType.SUBTREE_CHANGED:
                if (state.treeRoot === undefined) {
                    return state;
                }
                let newTreeRoot = {...state.treeRoot};
                let currentSubtree = findSubTreeByNodeId(newTreeRoot, action.nodeId);
                if (currentSubtree === undefined) {
                    return state;
                }
                currentSubtree.subTreeHasUnapprovedChanges = action.hasChanges;
                currentSubtree.nodeHasChanges = action.hasOwnProperty('changesInNode') ? action.changesInNode : action.hasChanges;

                if (action.hasChanges) {
                    // propagate up
                    while (currentSubtree !== undefined) {
                        currentSubtree = findSubTreeByNodeId(newTreeRoot, currentSubtree.parentId);
                        if (currentSubtree) {
                            currentSubtree.subTreeHasUnapprovedChanges = true;
                        }
                    }
                } else {
                    // if changes rejected / approved, go up and check if subtree still has some changes
                    while (currentSubtree !== undefined) {
                        currentSubtree = findSubTreeByNodeId(newTreeRoot, currentSubtree.parentId);
                        if (currentSubtree) {
                            let currentNodeHasChanges = false;
                            for (let i = 0; i < currentSubtree.children.length; i++) {
                                let childTree = currentSubtree.children[i];

                                if (childTree.subTreeHasUnapprovedChanges) {
                                    currentNodeHasChanges = true;
                                }
                            }
                            currentSubtree.subTreeHasUnapprovedChanges = currentSubtree?.nodeHasChanges || currentNodeHasChanges;
                        }
                    }
                }
                return {
                    ...state,
                    treeRoot: newTreeRoot
                }
            default:
                return state;
        }
    }
